<template>
  <div
    class="tip1_module_look trans"
    :style="bigBox"
    v-watermark="{
      text: appMobilePhone,
      textColor: 'rgba(180, 180, 180, 0.3)',
    }"
  >
    <div class="fill_title1 pos1">
      <div>查看处方</div>
      <div class="close_x pointer" @click="lookModule">
        <img src="../img/x.png" class="x-size" />
      </div>
    </div>
    <!-- -->
    <div class="flex-look" v-if="OrderInfo">
      <div>
        <viewer :images="OrderFileUrl">
          <img
            :src="OrderFileUrl[0]"
            id="jqImg"
            class="pointer imgSize"
            :style="imgBox"
          />
        </viewer>
        <div style="display: none">
          <!-- {{style="display:none" }} -->
          <section ref="print">
            <dom-print :InquiryId="InquiryId"></dom-print>
          </section>
        </div>
      </div>
      <div
        class="msgBox"
        :style="infoBox"
        v-watermark="{
          text: appMobilePhone,
          textColor: 'rgba(180, 180, 180, 0.3)',
        }"
      >
        <div>
          <div>
            <div class="topTitle rAl font-title">处方信息</div>
            <div class="rAl-title">
              <div>
                <span class="font-title">基本信息</span>
                <!-- <span class="rAl font-s">处方id：{{OrderInfo.OrderId}}</span> -->
              </div>
              <div class="border-b font-s">
                <div class="flex2">
                  <div class="rAl">
                    <div class="m-top">姓名：{{ OrderInfo.Name }}</div>
                    <div class="m-top">电话：{{ OrderInfo.Mobilephone }}</div>
                  </div>
                  <div class="rAl">
                    <div class="m-top">年龄：{{ OrderInfo.Age }}</div>
                    <div class="m-top">
                      性别：{{ OrderInfo.Sex == 2 ? "女" : "男" }}
                    </div>
                  </div>
                  <div class="rAl">
                    <div class="m-top" style="visibility: hidden">隐藏</div>
                    <div class="m-top">体重：{{ OrderInfo.Weight }}kg</div>
                  </div>
                </div>
              </div>
              <div class="border-b font-s">
                <div class="flex2">
                  <div class="rAl">
                    <div class="m-top">
                      肝功能异常：{{
                        OrderInfo.LiverType == 0 ? "正常" : "异常"
                      }}
                    </div>
                    <div class="m-top">
                      过敏史：{{
                        OrderInfo.AMHType == 0 ? "无" : OrderInfo.AMHDesc
                      }}
                    </div>
                    <div class="m-top">
                      家族史：{{
                        OrderInfo.FMHType == 0 ? "无" : OrderInfo.FMHDesc
                      }}
                    </div>
                  </div>
                  <div class="rAl">
                    <div class="m-top">
                      肾功能异常：{{
                        OrderInfo.RenalType == 0 ? "正常" : "异常"
                      }}
                    </div>
                    <div class="m-top">
                      既往史：{{
                        OrderInfo.PMHType == 0 ? "无" : OrderInfo.PMHDesc
                      }}
                    </div>
                    <div class="m-top">
                      备孕、妊娠、哺乳：
                      {{
                        OrderInfo.NurseType == 0
                          ? "无"
                          : OrderInfo.NurseDesc == null
                          ? "无"
                          : OrderInfo.NurseDesc
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="rAl-title">
              <div>
                <span class="font-title">临床诊断</span>
              </div>
              <div class="border-b font-s">
                <div class="flex2">
                  <div class="rAl">
                    <div class="m-top">主诊断：{{ OrderInfo.Diseases }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="rAl-title">
              <div>
                <span class="font-title">RP</span>
              </div>
              <div class="border-b font-s">
                <div>
                  <div
                    class="rAl"
                    v-for="(item, i) in OrderInfo.DrugsList"
                    :key="i"
                  >
                    <div class="m-top">
                      {{ item.CommonName }} ，
                      <span v-if="OrderInfo.CNDrugsType != 3">
                        {{ item.Specs }} ，
                      </span>
                      {{ item.Count }}{{ item.CountUnit }}
                    </div>
                    <div class="m-top ce4">
                      用法用量：{{ item.Usage }}，{{ "一次" + item.DoseValue
                      }}{{ item.DoseUnit }} ，{{ item.FrequencyValue
                      }}{{ item.FrequencyUnit }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="rAl-title">
              <div>
                <span class="font-title">签名信息</span>
                <span class="pointer signature" @click="oneKeySignature"
                  >药师签名</span
                >
              </div>
              <div class="border-b font-s">
                <div>
                  <div class="rAl">
                    <div class="m-top">
                      <span>医师：{{ OrderInfo.DoctorName }}</span>
                      <!-- <img
                        class="img-size"
                        v-if="OrderInfo.DoctorNameUrl&&OrderInfo.DoctorNameUrl.length>0"
                        :src="OrderInfo.DoctorNameUrl"
                        alt
                      />-->
                    </div>
                    <!-- {{OrderInfo}} -->
                    <!-- <div class="m-top">
                      <span>院内审核药师：{{ OrderInfo.DoctorName }}</span>
            
                    </div> -->
                    <div class="m-top">
                      <span>审核药师：</span>
                      <img
                        class="img-size"
                        v-if="
                          OrderInfo.PharAuditNameUrl &&
                          OrderInfo.PharAuditNameUrl.length > 0
                        "
                        :src="OrderInfo.PharAuditNameUrl"
                      />
                    </div>
                    <div class="m-top">
                      <span>调配药师/士：</span>
                      <img
                        class="img-size"
                        v-if="
                          OrderInfo.PharDispensingNameUrl &&
                          OrderInfo.PharDispensingNameUrl.length > 0
                        "
                        :src="OrderInfo.PharDispensingNameUrl"
                      />
                    </div>
                    <div class="m-top">
                      <span>复核/发药药师：</span>
                      <img
                        class="img-size"
                        v-if="
                          OrderInfo.PharReviewNameUrl &&
                          OrderInfo.PharReviewNameUrl.length > 0
                        "
                        :src="OrderInfo.PharReviewNameUrl"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="rAl-title">开具日期：{{ OrderInfo.OrderTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-look spinStr" :style="imgBox" v-else>
      <Spin size="large">加载中...</Spin>
    </div>
    <div class="view_pre_double_btn flex2">
      <div class="pointer" @click="printPrescriptionJq">打印处方</div>
      <div class="pointer" @click="savePrescription">保存处方</div>
    </div>
  </div>
</template>
<script>
import {
  AuditPrescribe,
  CheckPharSignImg,
  GetPrescribe,
  DownLoadToBase64,
  CheckPhar,
} from "@/utils/api.js";
import "@/utils/jquery.jqprint-0.3";
import domPrint from "@/components/domPrint";
export default {
  props: {
    InquiryId: {
      type: String,
      default: false,
    },
  },
  components: {
    domPrint,
  },

  data() {
    return {
      OrderFileUrl: [],
      OrderInfo: null,
      appMobilePhone: "",
      swidth: 900,
      sHeight: 750,
      bigBox: { width: 900 + "px", height: 750 + "px" },
      imgBox: { width: 438 + "px", height: 620 + "px" },
      infoBox: { width: 438 + "px", height: 620 + "px" },
    };
  },
  methods: {
    //单个打印出发
    printPrescription() {
      this.$print(this.$refs.print); // 使用
    },
    printPrescriptionJq(row) {
      this.printPrescription();
      // $("#jqImg").jqprint({
      //   debug: false,
      //   importCSS: false,
      //   printContainer: true,
      //   operaSupport: false
      // });
    },
    //保存处方
    savePrescription() {
      var msg = {
        url: this.OrderFileUrl,
        id: this.InquiryId,
        base64: true,
      };
      this.$store.dispatch("downloads", msg);
    },
    //药师签名
    oneKeySignature() {
      CheckPhar({}).then((res) => {
        //判断是否是远程药师权限！
        sessionStorage.setItem(
          "PharAuditNameUrl",
          this.OrderInfo.PharAuditNameUrl
        );
        sessionStorage.setItem(
          "PharDispensingNameUrl",
          this.OrderInfo.PharDispensingNameUrl
        );

        sessionStorage.setItem(
          "PharReviewNameUrl",
          this.OrderInfo.PharReviewNameUrl
        );
        if (res.code == 1) {
          this.$store.commit("upadateSignUrl", res.data.SignImg);
          //判断是否有图片
          if (res.data.SignImg && res.data.SignImg.length > 0) {
            //有图片判断是否需要远程审方
            if (
              this.OrderInfo.PrescriptionStatus == null ||
              this.OrderInfo.PrescriptionStatus == 0
            ) {
              //等于PrescriptionStatus0是单体门店
              this.$emit("noeModules", 3);
            } else if (this.OrderInfo.PrescriptionStatus == 99) {
              this.$Message.error("远程审方已拒绝，不能进行调配发药。");
            } else {
              //需要远程审方判断是否是远程药师
              if (res.data.IsParentPhar) {
                this.$emit("noeModules", 3);
              } else {
                if (
                  this.OrderInfo.PharAuditNameUrl &&
                  this.OrderInfo.PharAuditNameUrl.length > 0
                ) {
                  this.$emit("noeModules", 2);
                } else {
                  this.$Message.error(
                    "远程审方完成后才能进行此操作，请联系远程药师尽快审核。"
                  );
                }
              }
            }
          } else {
            this.$Modal.info({
              title: "药师签名",
              content:
                "您还没有药师签名，请到【莲藕健康APP—我的—完善药师信息】进行完善。",
            });
          }
        } else {
          this.$Modal.info({
            title: "药师签名",
            content: res.msg,
          });
        }
      });
    },
    lookModule() {
      this.$emit("lookModule");
    },
    // 点击查看处方
    clickSeePrescription() {
      var pamas = {
        LoInquiryId: this.InquiryId,
      };
      GetPrescribe(pamas).then((res) => {
        console.log(JSON.stringify(res.data));
        if (res.code == 1) {
          this.OrderInfo = res.data;
          this.OrderFileUrl = [res.data.OrderFileUrl];
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
  },
  mounted() {
    this.sWidth = document.body.clientWidth;
    this.sHeight = document.body.clientHeight;
    this.appMobilePhone = localStorage.getItem("app_mobile");
    if (this.sHeight < 800) {
      this.bigBox = {
        width: this.swidth * 0.9 + "px",
        height: this.sHeight * 0.87 + "px",
      };
      this.imgBox = {
        width: this.swidth * 0.47 - 50 + "px",
        height: this.sHeight * 0.77 - 90 + "px",
      };
      this.infoBox = {
        width: 900 - (this.swidth * 0.47 - 60) + "px",
        height: this.sHeight * 0.77 - 90 + "px",
      };
    }
    this.clickSeePrescription();
  },
};
</script>
<style lang="scss" scoped>
.tip1_module_look {
  position: absolute;
  background-color: #f2f2f2;
  text-align: center;
  width: 900px;
  height: 750px;
  .spinStr {
    display: inline-block;
    position: relative;
    top: 35%;
    left: 45%;
  }
  .img-size {
    width: 50px;
    height: 20px;
  }
  .rAl {
    padding: 0 15px;
  }
  .rAl-title {
    padding: 5px 25px;
  }
  .m-top {
    margin-top: 2px;
  }
  .font-title {
    font-size: 14px;
    font-weight: bold;
  }
  .font-s {
    font-size: 8px;
  }
  .border-b {
    border-bottom: 1px solid #f2f2f2;
    padding: 5px 0 10px 0;
  }
  .ce4 {
    color: #817f7f;
  }
  .signature {
    background: rgba(47, 49, 139, 1);
    float: right;
    color: #fff;
    font-size: 8px;
    padding: 2px 5px;
    border-radius: 2px;
  }
  .msgBox {
    text-align: left;
    margin-left: 10px;
    width: 438px;
    height: 620px;
    background-color: #fff;
    overflow-y: scroll;
    .topTitle {
      width: 100%;
      height: 35px;
      line-height: 35px;
      background: #fbfbfb;
    }
  }
  .pointer {
    cursor: pointer;
  }
  .fill_title1 {
    height: 56px;
    background: rgba(47, 49, 139, 1);
    text-align: center;
    line-height: 56px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    margin-bottom: 20px;
  }
  .close_x {
    font-size: 16px;
    position: absolute;
    right: 20px;
    font-weight: 500;
    top: 50%;
    transform: translateY(-50%);
  }
  .x-size {
    width: 12px;
    height: 12px;
  }
  .flex-look {
    display: flex;
    padding: 0 20px;
  }
  .imgSize {
    width: 438px;
    height: 620px;
  }
  .view_pre_double_btn {
    margin-top: 10px;
    justify-content: center;
    div:first-child {
      width: 106px;
      height: 36px;
      border: 1px solid rgba(47, 49, 139, 1);
      border-radius: 4px;
      text-align: center;
      line-height: 36px;
      box-sizing: border-box;
      margin-right: 51px;
      color: rgba(47, 49, 139, 1);
    }
    div:last-child {
      width: 106px;
      height: 36px;
      background: rgba(47, 49, 139, 1);
      border-radius: 4px;
      text-align: center;
      line-height: 36px;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>